import React, { useCallback, useEffect, useRef, useState } from 'react';
import Header from '../../components/Header';
import {
  API_KEY,
  API_POSTS,
  API_POSTS_DELETE,
  API_CLIENTS_NAME,
  API_POSTS_MONTH,
  API_POSTS_EDIT,
  API_GENERATE_AI_POST,
  API_GET_CONTENT_STRATEGIES,
  API_GET_PROMPTS,
  MONTHS_TO_GENERATE,
  API_GENERATE_AI_POST_V2,
  API_GENERATE_AI_POST_V2_NO_AI
} from '../../utils';
import Countdown from './counter';

import ViewPostsInCalendar from '../../components/ViewPostsInCalendar';
import UserGalleryModal from './GallerySection/UserGalleryModal.js';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeline from '@fullcalendar/timeline';
import list from '@fullcalendar/list';
import Swal from 'sweetalert2';
import bootstrap from '@fullcalendar/bootstrap';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import Select from 'react-select';
import { Link, useHistory } from 'react-router-dom';
import Clock from 'react-live-clock';
import { useDispatch, useSelector } from 'react-redux';
import ReactDOM from 'react-dom';
import { postsSelector, setSelectedPost } from '../../store/slices/posts';
import { clientsSelector, getClients } from '../../store/slices/clients';
import {
  setSelectedClient,
  selectedClientSelector
} from '../../store/slices/selectedClient';
import { SearchIcon, NotesIcon } from '../../Icons';

import PostsSection from './PostsSection/PostsSection';
import NewPost from '../../components/NewPost';
import { authSelector } from '../../store/slices/auth';
import * as Theme from '../../theme/theme';
import './Calendar.scss';
import './Modal-calendar.css';
import NotesModal from '../../components/Notes/NotesModal.js';
import AccountStatus from '../../components/Notes/AccountStatus';
import { NotesProvider } from '../../components/Notes/NotesContext';
import AIToolsPost from '../../components/AIToolsPost';
import XLSX from 'xlsx';
import {
  resetContentState,
  generateContent as showLoadingModal
} from '../../store/slices/generalState';
import LoadingModal from './LoadingModal';
import LoadingSpinner from '../../pages/Calendar/GallerySection/StockImagesComponents/Partials/LoadingSpinner';
import TooltipInfo from '../Client/TooltipInfo/tooltipInfo.js';
import { showLoading, hideLoading } from '../../store/slices/loadingState';
import { allowedEmails } from '../../utils';

const moment = require('moment-timezone');
const axios = require('axios');

function CalendarScreen({ match }) {
  const newPostRef = useRef(null);
  const viewPostRef = useRef(null);
  const userGalleryRef = useRef(null);
  const iAPostToolsRef = useRef(null);
  const calendarRef = useRef(null);
  const history = useHistory();
  const [imagesLimit, setImagesLimit] = useState(3);
  const [refresh, setRefresh] = useState(true);
  const { customerList } = useSelector(clientsSelector);
  const { selectedClient } = useSelector(selectedClientSelector);
  const { selectedPost } = useSelector(postsSelector);
  const [loadingPosts, SetLoadingPosts] = useState(undefined);
  const [postsLists, SetPostsLists] = useState([]);
  const [newPost, setNewPost] = useState(undefined);
  const [listSelectedToDelete, setListSelectedToDelete] = useState([]);
  const [listSelectedtoSwitch, setListSelectedtoSwitch] = useState([]);
  const [queryDate, setQueryDate] = useState(
    `${new Date().getMonth() + 1} ${new Date().getFullYear()}`
  );
  const [checkDeleteMultiple, setCheckDeleteMultiple] = useState(false);
  const [checkSwitchMultiple, setCheckSwitchMultiple] = useState(false);
  const dispatch = useDispatch();
  const { userInfo } = useSelector(authSelector);
  const currentEmail = userInfo?.email;
  const currentRole = userInfo?.role;
  const { shouldGenerateContent } = useSelector((state) => state.generalState);
  const [refresh2, setRefresh2] = useState(false);
  const [isGenerating, setIsGenerating] = useState(false);
  const [blockingClientId, setBlockingClientId] = useState(null);
  const [generationStartTime, setGenerationStartTime] = useState(null);
  const [totalLoaded, setTotalLoaded] = useState(1);
  const [totalDays, setTotalDays] = useState(1);
  const [error, setError] = useState('');
  const [showPrompts, setShowPrompts] = useState(false);
  const [contentStrategy, setContentStrategy] = useState({});
  const [showImages, setShowImages] = useState(false);
  const [contentStrategyName, setContentStrategyName] = useState('');
  const [isContentAgentProcessing, setIsContentAgentProcessing] =
    useState(false);

  useEffect(() => {
    const tooltipTriggerList = Array.from(
      document.querySelectorAll('[data-bs-toggle="tooltip"]')
    );
    tooltipTriggerList.forEach((el) => new window.bootstrap.Tooltip(el));
  }, []);

  useEffect(() => {
    if (showPrompts) {
      axios
        .get(
          `${API_GET_CONTENT_STRATEGIES}?id=${selectedClient?.contentStrategy}`,
          {}
        )
        .then((res) => {
          setContentStrategy(res?.data?.contentStrategies);
        });
    }
  }, [showPrompts, selectedClient.userId, selectedClient?.contentStrategy]);

  useEffect(() => {
    axios
      .get(
        `${API_GET_CONTENT_STRATEGIES}?id=${selectedClient?.contentStrategy}`,
        {}
      )
      .then((res) => {
        setContentStrategyName(res?.data?.contentStrategies?.strategyName);
      });
  }, [selectedClient?.contentStrategy]);

  useEffect(() => {
    setShowPrompts(false);
  }, [selectedClient.id]);

  useEffect(() => {
    if (customerList.length === 0) {
      dispatch(getClients());
    }
  }, [customerList, dispatch]);
  useEffect(() => {
    if (customerList.length === 0) {
      dispatch(getClients());
    }
  }, []);

  const handleShowPrompts = () => {
    SetPostsLists([]);

    setShowPrompts(!showPrompts);
  };

  const handleShowImages = () => {
    setShowImages(!showImages);
    // Force calendar re-render to apply/remove show-images-mode styles
    setTimeout(() => {
      if (calendarRef.current) {
        calendarRef.current.render();
      }
    }, 100);
  };

  useEffect(() => {
    async function getURLClient() {
      const client = await axios.get(`${API_CLIENTS_NAME}${match.params.id}`, {
        headers: {
          'X-API-KEY': API_KEY,
          Authorization: `bearer ${userInfo.accessToken}`
        }
      });

      if (client.data) {
        dispatch(setSelectedClient(client.data));
      }
      return client;
    }

    getURLClient();
    // eslint-disable-next-line
  }, [match.params.id]);

  useEffect(() => {
    if (queryDate && selectedClient.currentClientId !== '') {
      fetchPosts(queryDate);
    }

    // eslint-disable-next-line
  }, [queryDate, selectedClient, showPrompts]);

  useEffect(() => {
    setNewPost();
  }, [newPost]);

  useEffect(() => {
    setRefresh2(!refresh2);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [postsLists]);

  const customStyles = {
    menu: (provided, state) => ({
      ...provided,
      width: '100%',
      color: state.selectProps.menuColor,
      padding: 10,
      overflow: 'hidden',
      backgroundColor: 'white', // White background for the menu
      zIndex: 9999
    }),
    control: (_, { selectProps: { width } }) => ({
      width: width
    }),
    indicatorsContainer: () => ({
      display: 'none'
    }),
    placeholder: (provided) => ({
      ...provided,
      color: '#c3c3c3',
      marginTop: '0.2em'
    }),
    input: (provided) => ({
      ...provided,
      marginTop: '0.5em'
    }),

    singleValue: (provided, state) => {
      const opacity = state.isDisabled ? 0.5 : 1;
      const transition = 'opacity 300ms';

      return { ...provided, opacity, transition };
    }
  };
  const checkDeleteMultipleState = () => {
    setCheckDeleteMultiple(!checkDeleteMultiple);
    setListSelectedToDelete([]);
    if (checkDeleteMultiple === false) {
      setListSelectedToDelete([]);
    }
  };

  const checkSwitchMultipleState = () => {
    setCheckSwitchMultiple(!checkSwitchMultiple);
    setListSelectedtoSwitch([]);
    if (checkSwitchMultiple === false) {
      setListSelectedtoSwitch([]);
    }
  };

  // Function to determine if a client is new (created in the last 10 minutes)
  const isNewClient = (client) => {
    if (!client?.createdAt) return false;
    const createdAt =
      typeof client.createdAt === 'number'
        ? client.createdAt
        : new Date(client.createdAt).getTime();
    const tenMinutesAgo = Date.now() - 10 * 60 * 1000;
    return createdAt > tenMinutesAgo;
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const fetchPosts = async (date) => {
    try {
      let arr = date.split(' ');
      const month = Number(arr[0]);
      const year = Number(arr[1]);
      let dateNow = {
        year: year.toString(),
        month: month.toString(),
        clientId: selectedClient.id
      };
      dispatch(showLoading());
      SetLoadingPosts(true);
      // HERE WE ASK FOR POSTS
      let res = showPrompts
        ? await axios.request({
            method: 'post',
            url: API_GET_PROMPTS,
            data: {
              csId: selectedClient?.clientGroups[0]?.id,
              clId: selectedClient.id,
              timeZone: selectedClient.timeZone,
              month: dateNow.month,
              year: dateNow.year
            }
          })
        : await axios.post(API_POSTS_MONTH, {
            ...dateNow,
            timeZone: selectedClient.timeZone
          });

      //
      SetPostsLists(showPrompts ? res.data.mergedArray : res.data.posts);
      dispatch(hideLoading());
      if (!selectedClient.firstGenerationByAI) {
        SetLoadingPosts(false);
      }
      return showPrompts ? res.data.mergedArray : res.data.posts;
    } catch (error) {
      console.error(error);
    }
  };
  const getTime = (currentClientTimeZone, datePost) => {
    let date = null;
    switch (currentClientTimeZone) {
      case 'Eastern Daylight Time - (GMT-4)':
        date = moment(datePost)
          .tz('America/New_York')
          .format('YYYY-MM-DDTHH:mm');
        break;
      case 'Central Daylight Time - (GMT-5)':
        date = moment(datePost)
          .tz('America/Chicago')
          .format('YYYY-MM-DDTHH:mm');
        break;
      case 'Mountain Daylight Time - (GMT-6)':
        date = moment(datePost).tz('America/Denver').format('YYYY-MM-DDTHH:mm');
        break;
      case 'Mountain Standard Time - (GMT-7)':
        date = moment(datePost)
          .tz('America/Phoenix')
          .format('YYYY-MM-DDTHH:mm');
        break;
      case 'Pacific Daylight Time - (GMT-7)':
        date = moment(datePost)
          .tz('America/Los_Angeles')
          .format('YYYY-MM-DDTHH:mm');
        break;
      case 'Alaska Daylight Time - (GMT-8)':
        date = moment(datePost)
          .tz('America/Anchorage')
          .format('YYYY-MM-DDTHH:mm');
        break;
      default:
        date = moment(datePost)
          .tz('Pacific/Honolulu')
          .format('YYYY-MM-DDTHH:mm');
        break;
    }
    return date;
  };

  const getTimeZoneClock = (currentClientTimeZone) => {
    let timeZoneClock = null;
    switch (currentClientTimeZone) {
      case 'Eastern Daylight Time - (GMT-4)':
        timeZoneClock = 'America/New_York';
        break;
      case 'Central Daylight Time - (GMT-5)':
        timeZoneClock = 'America/Chicago';
        break;
      case 'Mountain Daylight Time - (GMT-6)':
        timeZoneClock = 'America/Denver';
        break;
      case 'Mountain Standard Time - (GMT-7)':
        timeZoneClock = 'America/Phoenix';
        break;
      case 'Pacific Daylight Time - (GMT-7)':
        timeZoneClock = 'America/Los_Angeles';
        break;
      case 'Alaska Daylight Time - (GMT-8)':
        timeZoneClock = 'America/Anchorage';
        break;
      default:
        timeZoneClock = 'Pacific/Honolulu';
        break;
    }
    return timeZoneClock;
  };

  const imagesSection = () => {
    return (
      <PostsSection
        changeView={() => setImagesLimit(imagesLimit + 3)}
        limit={imagesLimit}
        postsListData={!showPrompts ? postsLists : []}
        client={selectedClient}
        setState={(data) => {
          setQueryDate(`${data.monthFilterPosts} ${data.yearFilterPosts}`);
        }}
        monthFilterPosts={queryDate.split(' ')[0]}
        yearFilterPosts={queryDate.split(' ')[1]}
      />
    );
  };

  const onSelectPost = (event, forced) => {
    if (event.view.type === 'listMonth' && !forced) return;
    let obj = event.event;
    if (!(checkDeleteMultiple || checkSwitchMultiple)) {
      let images = obj._def.extendedProps.images;
      let post = {
        id: obj.id,
        title: obj.title,
        start: obj.start,
        backgroundColor: obj.backgroundColor,
        images: images,
        client: selectedClient,
        socialNetworks: obj._def.extendedProps.socialNetworks,
        status: obj._def.extendedProps.status,
        createdBy: obj._def.extendedProps.createdBy,
        createdAt: obj._def.extendedProps.createdAt,
        hashtagsig: obj._def.extendedProps.hashtagsig,
        SK: obj._def.extendedProps.SK,
        updatedAt: obj._def.extendedProps.updatedAt,
        editedBy: obj._def.extendedProps.editedBy,
        isPromotional: obj._def.extendedProps.isPromotional,
        isOffer: obj._def.extendedProps.isOffer
      };
      dispatch(setSelectedPost(post));
      if (event.oldEvent === undefined) {
        // viewPostBtn.current.click();
        const modalElement = viewPostRef.current;
        const bootstrapModal = new window.bootstrap.Modal(modalElement);
        bootstrapModal.show();
      } else {
        editPost(post);
      }
    } else {
      if (
        (obj.extendedProps.status === 'Schedule' ||
          obj.extendedProps.status === 'Draft' ||
          obj.extendedProps.status === 'Promo') &&
        checkDeleteMultiple
      ) {
        if (listSelectedToDelete.indexOf(obj.id) === -1) {
          setListSelectedToDelete([...listSelectedToDelete, obj.id]);
        } else {
          let index = listSelectedToDelete.indexOf(obj.id);
          if (index > -1) {
            setListSelectedToDelete((listSelectedToDelete) =>
              listSelectedToDelete.filter((img, i) => i !== index)
            );
          }
        }
      } else if (
        (obj.extendedProps.status === 'Schedule' ||
          obj.extendedProps.status === 'Draft') &&
        checkSwitchMultiple
      ) {
        if (listSelectedtoSwitch.indexOf(obj.id) === -1) {
          setListSelectedtoSwitch([...listSelectedtoSwitch, obj.id]);
        } else {
          let index = listSelectedtoSwitch.indexOf(obj.id);
          if (index > -1) {
            setListSelectedtoSwitch((listSelectedtoSwitch) =>
              listSelectedtoSwitch.filter((img, i) => i !== index)
            );
          }
        }
      }
    }
  };
  const getStatusPost = async (id) => {
    if (queryDate && selectedClient.currentClientId !== '') {
      await fetchPosts(queryDate);
      const isSameId = (element) => element.id === id;
      const idx = postsLists.findIndex(isSameId);
      const post = { ...postsLists[idx], isDraft: false };
      dispatch(setSelectedPost(post));
    }
  };
  const getCalendarDate = async (
    fetchInfo,
    successCallback,
    failureCallback
  ) => {
    setQueryDate(
      `${new Date(fetchInfo.start).getMonth() + 1} ${new Date(
        fetchInfo.start
      ).getFullYear()}`
    );
    let postToCalendar = postsLists.map((post) => {
      let datePost = post.schedule || post.createdAt;
      let isDraft = post.isDraft;
      let datePost2 = moment.unix(datePost).format('YYYY-MM-DDTHH:mm');
      let dateNow = moment.utc(new Date()).unix();
      let statusPost = { status: 0, selected: checkDeleteMultiple };
      let valuesPost = {};
      let hashtagsig = post?.hashtagsig;
      if (isDraft) {
        statusPost.status = 2; // DRAFT
      } else if (post.createdBy === 'APP') {
        statusPost.status = 3; // APP
      } else if (post?.prompt) {
        statusPost.status = 4; // PROMPT
      } else if (post?.isPromotional) {
        statusPost.status = 5; // PROMOTIONAL
      } else if (post?.isOffer) {
        statusPost.status = 6; // OFFER
      } else {
        statusPost.status = datePost > dateNow - 10 ? 1 : 0; //0 posted | 1 schedule
      }

      switch (true) {
        case statusPost.status === 0: // posted Status
          valuesPost['startEditable'] = true;
          valuesPost['status'] = 'Posted';
          valuesPost['borderColor'] =
            listSelectedToDelete.includes(post.id) && checkDeleteMultiple
              ? Theme.deleteColor
              : Theme.postedColor;
          valuesPost['backgroundColor'] =
            listSelectedToDelete.includes(post.id) && checkDeleteMultiple
              ? Theme.deleteColor
              : Theme.postedColor;
          break;

        case statusPost.status === 1: // scheduled Status
          valuesPost['startEditable'] = true;
          valuesPost['status'] = 'Schedule';
          valuesPost['borderColor'] =
            listSelectedToDelete.includes(post.id) && checkDeleteMultiple
              ? Theme.deleteColor
              : Theme.scheduledColor;
          valuesPost['backgroundColor'] =
            listSelectedToDelete.includes(post.id) && checkDeleteMultiple
              ? Theme.deleteColor
              : listSelectedtoSwitch.includes(post.id) && checkSwitchMultiple
              ? Theme.infoColor
              : Theme.scheduledColor;
          break;

        case statusPost.status === 3: // APP Status
          valuesPost['startEditable'] =
            checkDeleteMultiple || checkSwitchMultiple ? false : true;
          valuesPost['status'] = 'App';
          valuesPost['borderColor'] =
            listSelectedToDelete.includes(post.id) && checkDeleteMultiple
              ? Theme.deleteColor
              : Theme.appColor;
          valuesPost['backgroundColor'] =
            listSelectedToDelete.includes(post.id) && checkDeleteMultiple
              ? Theme.deleteColor
              : Theme.appColor;
          break;
        case statusPost.status === 4:
          valuesPost['startEditable'] = true;
          valuesPost['status'] = 'Prompt';
          valuesPost['borderColor'] = Theme.promptColor;
          valuesPost['backgroundColor'] = Theme.promptColor;
          break;

        case statusPost.status === 5:
          valuesPost['startEditable'] = true;
          valuesPost['status'] = 'Promo';
          valuesPost['borderColor'] =
            listSelectedToDelete.includes(post.id) && checkDeleteMultiple
              ? Theme.deleteColor
              : Theme.promoColor;
          valuesPost['backgroundColor'] =
            listSelectedToDelete.includes(post.id) && checkDeleteMultiple
              ? Theme.deleteColor
              : Theme.promoColor;
          break;

        case statusPost.status === 6:
          valuesPost['startEditable'] = true;
          valuesPost['status'] = 'Offer';
          valuesPost['borderColor'] =
            listSelectedToDelete.includes(post.id) && checkDeleteMultiple
              ? Theme.deleteColor
              : Theme.offerColor;
          valuesPost['backgroundColor'] =
            listSelectedToDelete.includes(post.id) && checkDeleteMultiple
              ? Theme.deleteColor
              : Theme.offerColor;
          break;

        default:
          // Draft Status
          valuesPost['startEditable'] = true;
          valuesPost['status'] = 'Draft';
          valuesPost['borderColor'] =
            listSelectedToDelete.includes(post.id) && checkDeleteMultiple
              ? Theme.deleteColor
              : Theme.draftColor;
          valuesPost['backgroundColor'] =
            listSelectedToDelete.includes(post.id) && checkDeleteMultiple
              ? Theme.deleteColor
              : listSelectedtoSwitch.includes(post.id) && checkSwitchMultiple
              ? Theme.infoColor
              : Theme.draftColor;
          break;
      }
      let start = getTime(selectedClient.timeZone, datePost2);
      return {
        id: post.id,
        title: post.message,
        start: start,
        startEditable: valuesPost['startEditable'],
        status: valuesPost['status'],
        borderColor: valuesPost['borderColor'],
        backgroundColor: valuesPost['backgroundColor'],
        textColor: '#fff',
        images: post.images,
        socialNetworks: post.socialNetworks,
        createdBy: post.createdBy,
        createdAt: post.createdAt,
        hashtagsig: hashtagsig,
        SK: post?.SK,
        updatedAt: post?.updatedAt,
        editedBy: post?.editedBy
      };
    });
    successCallback(postToCalendar);
  };

  const handleClickIATools = () => {
    // IAPostTools.current.click();
    console.log('handleClickIATools ...........');
    const modalElement = iAPostToolsRef.current;
    const bootstrapModal = new window.bootstrap.Modal(modalElement);
    bootstrapModal.show();
  };

  const handleDateClick = (arg) => {
    if (checkDeleteMultiple || checkSwitchMultiple) {
      return;
    }
    var current = new Date(getTime(selectedClient.timeZone));

    var onNewPost = {
      title: '',
      start: new Date(
        arg.date.setHours(current.getHours(), current.getMinutes())
      ),
      allDay: false,
      backgroundColor: Theme.scheduledColor,
      borderColor: '#0168fa',
      textColor: '#fff'
    };
    setNewPost(onNewPost);

    // addPostBtn.current.click();

    const modalElement = newPostRef.current;
    const bootstrapModal = new window.bootstrap.Modal(modalElement);
    bootstrapModal.show();
  };
  const editPost = (post) => {
    setNewPost(post);
    const modalElement = newPostRef.current;
    const bootstrapModal = new window.bootstrap.Modal(modalElement);
    bootstrapModal.show();
    //addPostBtn.current.click();
  };
  const rePost = (post) => {
    let data = {};
    let socialNetwork = {};
    Object.assign(data, post);
    delete data.id;
    data.status = 'Schedule';
    Object.assign(socialNetwork, data.socialNetworks);
    if (data.socialNetworks.facebookPosted === true) {
      socialNetwork.facebook = false;
    }
    if (data.socialNetworks.twitterPosted === true) {
      socialNetwork.twitter = false;
    }
    if (data.socialNetworks.instagramPosted === true) {
      socialNetwork.instagram = false;
    }
    if (data.socialNetworks.googleMyBusinessPosted === true) {
      socialNetwork.googleMyBusiness = false;
    }
    data.socialNetworks = socialNetwork;
    setNewPost(data);
    const modalElement = newPostRef.current;
    const bootstrapModal = new window.bootstrap.Modal(modalElement);
    bootstrapModal.show();
    // addPostBtn.current.click();
  };

  const repairPost = (post) => {
    let data = {};
    Object.assign(data, post);
    data.status = 'Schedule';
    data.isRepairingPost = true;
    setNewPost(data);
    const modalElement = newPostRef.current;
    const bootstrapModal = new window.bootstrap.Modal(modalElement);
    bootstrapModal.show();
    // addPostBtn.current.click();
  };

  const deletePost = async (id, options) => {
    await axios
      .post(API_POSTS_DELETE, {
        postId: id,
        clientId: selectedClient.id,
        deletedBy: {
          displayName: userInfo?.displayName,
          email: currentEmail,
          role: currentRole
        },
        options: options
      })
      .then((response) => {
        if (response.status === 200) {
          fetchPosts(queryDate);
        }
      });
  };

  const updatePost = (id) => {
    const isSameId = (element) => element.id === id;
    const idx = postsLists.findIndex(isSameId);
    const post = {
      ...postsLists[idx],
      createdBy: userInfo?.displayName,
      isDraft: !postsLists[idx].isDraft,
      posted: false,
      isScheduled: false
    };
    axios
      .post(API_POSTS_EDIT, JSON.stringify(post))
      .then((response) => {
        fetchPosts(queryDate);
      })
      .catch((error) => {
        fetchPosts(queryDate);
        if (error) {
          Swal.fire({
            title: 'error',
            text: 'We have trouble scheduling the publication'
          });
        }
        console.error(error);
      });
  };

  const updatePostsMultiple = () => {
    listSelectedtoSwitch.map((idPost) => {
      updatePost(idPost);
    });
    setListSelectedtoSwitch([]);
  };
  const deletePostMultiple = (options) => {
    listSelectedToDelete.map((idPost) => {
      deletePost(idPost, null);
    });
    setListSelectedToDelete([]);
  };

  const handleSelectAll = () => {
    let dateNow = moment.utc(new Date()).unix();
    const listFiltered = postsLists
      .map((post) => {
        return {
          id: post.id,
          isDraft: post.isDraft,
          posted: post.posted,
          createdBy: post.createdBy,
          schedule: post.schedule
        };
      })
      .filter((post) => {
        return post.createdBy !== 'APP' && post.schedule >= dateNow;
      })
      .map((post) => post.id);
    if (checkDeleteMultiple) {
      setListSelectedToDelete(listFiltered);
    } else if (checkSwitchMultiple) {
      setListSelectedtoSwitch(listFiltered);
    }
  };

  const handleChangeClient = (x) => {
    dispatch(setSelectedClient(x));
    setImagesLimit(3);
    let newUrl = x.clientName
      .replace(/\s+/g, '%20')
      .replace(/\//g, '%2F')
      .replace(/'/g, '%1D')
      .replace(/’/g, '%1E');
    history.push(`/calendar/${newUrl}`);
  };

  const handleProfileView = (x) => {
    let newUrl = x
      .replace(/\s+/g, '%20')
      .replace(/\//g, '%2F')
      .replace(/'/g, '%1D')
      .replace(/’/g, '%1E');
    history.push(`/client/${newUrl}`);
  };

  const [open, setOpen] = useState(false);
  const [clientModalId, setClientModalId] = useState(null);

  const handleNotesModal = useCallback((open, clientModalId) => {
    setOpen(!open);
    if (open) return setClientModalId(null);
    return setClientModalId(clientModalId);
  }, []);

  const handleGalleryModal = useCallback((open, clientModalId) => {
    const modalElement = userGalleryRef.current;
    const bootstrapModal = new window.bootstrap.Modal(modalElement);
    bootstrapModal.show();
  }, []);

  const carrouselModal = async (x, id) => {
    let idx = 0;
    for (
      idx = 0;
      idx < postsLists.length && selectedPost.id !== postsLists[idx].id;
      idx++
    );

    if (x === 1) {
      if (idx < postsLists.length - 1) {
        idx += 1;
      }
    } else if (x === 0) {
      if (idx > 0) {
        idx -= 1;
      }
    }
    let obj = postsLists[idx];
    if (x === 8) {
      let posts = await fetchPosts(queryDate);
      idx = 0;
      function findIndexByCondition(array, conditionFunction) {
        for (let i = 0; i < array.length; i++) {
          if (conditionFunction(array[i])) {
            return i; // Return the index when the condition is met
          }
        }
        return -1; // If no element is found that meets the condition
      }
      const condition = (item) => item.id === id;
      idx = findIndexByCondition(posts, condition);

      obj = posts[idx];
    }

    let statCurrPost = '';
    let colorBackground = '';
    let datePost = obj?.schedule || obj?.createdAt;
    let dateNow = moment.utc(new Date()).unix();
    if (obj?.isDraft) {
      statCurrPost = 'Draft'; //Draft
      colorBackground = '#7987a1';
    } else if (obj?.createdBy === 'APP') {
      statCurrPost = 'App';
      colorBackground = Theme.appColor;
    } else if (showPrompts) {
      statCurrPost = 'Prompt';
    } else if (obj?.isPromotional) {
      statCurrPost = 'Promo';
    } else if (obj?.isOffer) {
      statCurrPost = 'Offer';
    } else {
      statCurrPost = datePost > dateNow - 10 ? 'Schedule' : 'Posted'; //0 posted | 1 schedule
      colorBackground =
        statCurrPost === 'Posted' ? Theme.postedColor : Theme.scheduledColor;
    }

    let post = {
      id: obj?.id || id,
      title: obj?.message,
      start: obj?.schedule,
      backgroundColor: colorBackground,
      images: obj?.images,
      client: selectedClient,
      socialNetworks: obj?.socialNetworks,
      status: statCurrPost,
      createdBy: obj?.createdBy,
      createdAt: obj?.createdAt,
      hashtagsig: obj?.hashtagsig,
      SK: obj?.SK,
      updatedAt: obj?.updatedAt,
      editedBy: obj?.editedBy
    };
    dispatch(setSelectedPost(post));
  };

  const handleLoadingModal = useCallback(
    (open) => {
      dispatch(resetContentState());
      fetchPosts(queryDate);
    },
    [dispatch, fetchPosts, queryDate]
  );

  const viewPostBtn = useRef('#viewPost');
  const addPostBtn = useRef('#newPost');
  const IAPostTools = useRef('#iatools');

  let newUrl;
  if (selectedClient !== null) {
    newUrl = selectedClient.clientName
      .replace(/\s+/g, '%20')
      .replace(/\//g, '%2F')
      .replace(/'/g, '%1D')
      .replace(/’/g, '%1E');
  }
  const createAIPost = async (postAI) => {
    const urlAI = API_GENERATE_AI_POST;
    const url = API_POSTS;
    try {
      // Generate AI post
      const response = await axios
        .post(urlAI, JSON.stringify(postAI))
        .catch((error) => {
          console.error(error);
        });

      // Schedule the new post
      axios.post(url, JSON.stringify(response.data.response)).catch((error) => {
        console.error('An error has ocurred scheduling new posts', error);
      });
    } catch (err) {
      return 'An error has ocurred scheduling new posts';
    }
    return 'OK';
  };

  const formatDate = (day, month, year) => {
    // Add 0 to 1 digit numbers
    const formatedDay = day < 10 ? `0${day}` : day;
    const formatedMonth = month < 10 ? `0${month}` : month;

    // Concatenate the date
    const formatedDate = `${formatedDay}/${formatedMonth}/${year}`;

    return formatedDate;
  };

  const generateContent = async () => {
    setIsGenerating(true);
    // setTotalLoaded(0);
    // setTotalDays(1);

    // const postAI = {
    //   clientId: selectedClient.id,
    //   parcel: ''
    // };

    // const generate = async (post) => {
    //   let status = 'OK';
    //   status = await createAIPost(post);
    //   setTotalLoaded((prev) => prev + 1);
    //   return status;
    // };

    // const getNextMonthDates = (startDate) => {
    //   const dates = [];
    //   let currentDate = new Date(startDate);

    //   for (let i = 0; i < MONTHS_TO_GENERATE; i++) {
    //     // Generate dates depending of the month variable
    //     const lastDayOfMonth = new Date(
    //       currentDate.getFullYear(),
    //       currentDate.getMonth() + 1,
    //       0
    //     ).getDate();

    //     for (let day = currentDate.getDate(); day <= lastDayOfMonth; day++) {
    //       dates.push(
    //         new Date(currentDate.getFullYear(), currentDate.getMonth(), day)
    //       );
    //     }

    //     // Advance to the next month
    //     currentDate = new Date(
    //       currentDate.getFullYear(),
    //       currentDate.getMonth() + 1,
    //       1
    //     );
    //   }

    //   return dates;
    // };

    // const tomorrow = () => {
    //   const currentDate = new Date();
    //   currentDate.setDate(currentDate.getDate() + 1);
    //   return currentDate;
    // };

    // const startDate = tomorrow();
    // const datesToGenerate = getNextMonthDates(startDate);
    // setTotalDays(datesToGenerate?.length || 1);
    // let status = 'OK';
    // for (const date of datesToGenerate) {
    //   postAI.parcel = formatDate(
    //     date.getDate(),
    //     date.getMonth(),
    //     date.getFullYear()
    //   );
    //   if (status === 'OK') {
    //     status = await generate(postAI);
    //     setError('');
    //   } else {
    //     setError(status);
    //   }
    // }
    // if (status === 'OK') {
    //   dispatch(resetContentState()); // to reset the state
    //   setTotalDays(1);
    //   setTotalLoaded(0);
    //   fetchPosts(queryDate);
    // }
    // setIsGenerating(false);
  };

  useEffect(() => {
    if (blockingClientId && blockingClientId !== selectedClient?.id) {
      setIsGenerating(false);
      SetLoadingPosts(false);
      setBlockingClientId(null);
      setGenerationStartTime(null);
    }
  }, [selectedClient?.id, blockingClientId]);

  useEffect(() => {
    if (!isGenerating) return;
    let cancelled = false;
    const interval = setInterval(async () => {
      if (cancelled) return;
      try {
        const client = await axios.get(
          `${API_CLIENTS_NAME}${match.params.id}`,
          {
            headers: {
              'X-API-KEY': API_KEY,
              Authorization: `bearer ${userInfo.accessToken}`
            }
          }
        );
        if (client?.data) {
          dispatch(setSelectedClient(client.data));
        }
      } catch (e) {}
    }, 10000);

    return () => {
      cancelled = true;
      clearInterval(interval);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isGenerating, match.params.id]);

  useEffect(() => {
    if (
      shouldGenerateContent &&
      selectedClient &&
      isNewClient(selectedClient)
    ) {
      setIsGenerating(true);
      SetLoadingPosts(true);
      setBlockingClientId(selectedClient.id);
      setGenerationStartTime(selectedClient.createdAt);
    }
  }, [shouldGenerateContent, selectedClient]);

  // Show modal/block if generatingContentByAI is true (only if there is no active block)
  useEffect(() => {
    if (selectedClient?.generatingContentByAI === true && !isGenerating) {
      setIsGenerating(true);
      SetLoadingPosts(true);
      setBlockingClientId(selectedClient.id);
      setGenerationStartTime(
        selectedClient.generationStartedAt ||
          selectedClient.createdAt ||
          Date.now()
      );
    }
  }, [selectedClient?.generatingContentByAI, selectedClient?.id, isGenerating]);

  // Clear block if generatingContentByAI changes to false
  useEffect(() => {
    if (
      selectedClient?.generatingContentByAI === false &&
      isGenerating &&
      blockingClientId === selectedClient?.id
    ) {
      // If generatingContentByAI changes to false, clear the block
      setIsGenerating(false);
      SetLoadingPosts(false);
      setBlockingClientId(null);
      setGenerationStartTime(null);
    }
  }, [
    selectedClient?.generatingContentByAI,
    isGenerating,
    blockingClientId,
    selectedClient?.id
  ]);

  useEffect(() => {
    const applyTodayStyles = () => {
      const todayElements = document.querySelectorAll(
        '.fc-day-today .fc-daygrid-day-number'
      );
      todayElements.forEach((element) => {
        element.style.cssText = `
          background-color: #007bff !important;
          color: white !important;
          border-radius: 4px !important;
          width: 20px !important;
          height: 20px !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          position: absolute !important;
          top: 2px !important;
          right: 2px !important;
          z-index: 10 !important;
          font-size: 10px !important;
          font-weight: 600 !important;
          min-width: 20px !important;
          min-height: 20px !important;
          padding: 0 !important;
          line-height: 1 !important;
          box-sizing: border-box !important;
        `;
      });
    };
  }, [selectedClient, postsLists]);

  useEffect(() => {
    if (!selectedClient.clientName) return;

    if (typeof Storage !== 'undefined') {
      const today = new Date();
      const currentMonth = today.getMonth() + 1;
      const currentDay = today.getDate();

      const yesterday = new Date(localStorage.getItem('prevDate'));
      const prevMonth = yesterday.getMonth() + 1;
      const prevDay = yesterday.getDate();

      if (
        currentMonth !== prevMonth ||
        currentDay !== prevDay ||
        !localStorage.getItem('prevDate')
      ) {
        localStorage.setItem('prevDate', today.toDateString());
        localStorage.removeItem('notes');
      }
    }

    if (!localStorage.getItem('notes')) {
      const clientsNotices = [];
      if (selectedClient.clientName !== '') {
        clientsNotices.push(selectedClient.clientName);
      }
      localStorage.setItem('notes', JSON.stringify(clientsNotices));
      return;
    }

    const clientsNotices = JSON.parse(localStorage.getItem('notes'));
    if (!clientsNotices.includes(selectedClient.clientName)) {
      clientsNotices.push(selectedClient.clientName);
      localStorage.setItem('notes', JSON.stringify(clientsNotices));
      return;
    }
  }, [selectedClient]);

  const CustomListContent = (props) => {
    let post = props.obj.extendedProps;
    let id = props.obj.id;
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          width: '100%'
        }}>
        {post.images && post.images[0] && (
          <img
            style={{
              maxWidth: '260px',
              maxHeight: '130px',
              margin: '15px',
              objectFit: 'cover',
              borderRadius: '4px'
            }}
            src={post.images[0].url}
            alt="Post image"
          />
        )}
        <div
          style={{
            height: '90px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            marginLeft: '15px'
          }}>
          <div
            className="button-like-a nav-link"
            onClick={() => {
              onSelectPost(props.ev, true);
            }}>
            <i class="fas fa-eye fa-lg"></i>
          </div>
          {(post.status === 'Schedule' || post.status === 'Draft') &&
          !checkDeleteMultiple &&
          !checkSwitchMultiple ? (
            <>
              <div
                className="button-like-a nav-link"
                onClick={() => {
                  updatePost(id);
                }}>
                <i className="fas fa-lg fa-magic" />
              </div>
            </>
          ) : (
            <div
              style={{
                width: '50px'
              }}></div>
          )}
        </div>
      </div>
    );
  };

  return (
    <NotesProvider>
      <div className="content ht-100v pd-0">
        <div className="content-header">
          <div className="content-search">
            <SearchIcon />
            <Select
              styles={customStyles}
              className="form-control"
              type="search"
              placeholder="Search clients"
              onChange={(x) => handleChangeClient(x)}
              options={customerList.map((customer) => ({
                ...customer,
                label: customer.clientName,
                value: customer.clientName
              }))}
              hideSelectedOptions={true}
              controlShouldRenderValue={false}
            />
          </div>
          <div className="nav d-flex align-items-center">
            {customerList.length === 0 && <LoadingSpinner />}
            {customerList.length > 0 && (
              <div className="d-flex align-items-center">
                {customerList.findIndex(
                  (customer) => customer.id === selectedClient.id
                ) > 0 && (
                  <button
                    className="button-like-a"
                    onClick={() => {
                      let x = customerList.findIndex(
                        (customer) => customer.id === selectedClient.id
                      );
                      handleChangeClient(customerList[x - 1]);
                    }}>
                    <i class="fas fa-arrow-left" />
                  </button>
                )}

                <label className="mx-2">
                  {customerList.length > 0
                    ? `${
                        customerList.findIndex(
                          (customer) => customer.id === selectedClient.id
                        ) + 1
                      }/${customerList.length}`
                    : null}
                </label>

                {customerList.findIndex(
                  (customer) => customer.id === selectedClient.id
                ) <
                  customerList.length - 1 && (
                  <button
                    className="button-like-a"
                    onClick={() => {
                      let x = customerList.findIndex(
                        (customer) => customer.id === selectedClient.id
                      );
                      handleChangeClient(customerList[x + 1]);
                    }}>
                    <i class="fas fa-arrow-right" />
                  </button>
                )}
              </div>
            )}
          </div>
        </div>

        <div className="container-fluid z-1">
          <div className="row pt-3 pb- mr-0 ml-0">
            <div className="col-6 d-flex d-flex">
              <h2
                className="mg-b-0 tx-spacing--1"
                style={{ display: 'flex', alignItems: 'center' }}>
                {selectedClient.clientName}
                <TooltipInfo
                  accountOwner={selectedClient.accountOwner}
                  accountStatus={selectedClient.accountStatus}
                  clientFlags={selectedClient.clientFlags}
                />
              </h2>
            </div>
            {isGenerating ? (
              <div className="col-4">
                <div className="d-flex h-100 align-items-center justify-content-center gap-3">
                  <span className="text-muted">
                    AI Generation in progress...
                  </span>
                </div>
              </div>
            ) : (
              <div className="col-4">
                <div className="d-flex h-100 align-items-center justify-content-around gap-3">
                  <div className="custom-control custom-checkbox custom-checkbox-lg d-flex align-items-center gap-2">
                    <input
                      type="checkbox"
                      disabled={checkSwitchMultiple}
                      id="customCheckScheduledPosts"
                      onClick={checkDeleteMultipleState}
                      className="custom-control-input"
                    />
                    <label htmlFor="terms1" className="custom-control-label">
                      {listSelectedToDelete.length}
                    </label>
                    <button
                      type="button"
                      className="button-like-a nav-link p-0"
                      disabled={checkSwitchMultiple}
                      data-bs-toggle="tooltip"
                      title="Delete selected posts"
                      onClick={() => {
                        if (listSelectedToDelete.length > 0) {
                          Swal.fire({
                            title: 'Delete Posts',
                            text: 'Are you sure you want to delete these posts?',
                            showCloseButton: true,
                            showCancelButton: true
                          }).then((res) => {
                            if (res.value) deletePostMultiple();
                          });
                        }
                      }}>
                      <i className="far fa-lg fa-trash-alt"></i>
                    </button>
                  </div>
                  <div className="custom-control custom-checkbox-lg custom-checkbox d-flex align-items-center gap-2">
                    <input
                      type="checkbox"
                      disabled={checkDeleteMultiple}
                      id="mutipleSwitchPosts"
                      onClick={checkSwitchMultipleState}
                      className="custom-control-input"
                    />
                    <label htmlFor="terms1" className="custom-control-label">
                      {listSelectedtoSwitch.length}
                    </label>
                    <button
                      type="button"
                      className="button-like-a nav-link p-0"
                      data-bs-toggle="tooltip"
                      title="Select to switch posts status"
                      disabled={checkDeleteMultiple}
                      onClick={() => {
                        if (listSelectedtoSwitch.length > 0) {
                          Swal.fire({
                            title: 'Switch Post Status',
                            html: '<p>Are you sure you want to switch these posts status?<br/><br/><small>(Draft ↔ Scheduled)</small></p>',
                            showCloseButton: true,
                            showCancelButton: true
                          }).then((res) => {
                            if (res.value) updatePostsMultiple();
                          });
                        }
                      }}>
                      <i className="fas fa-lg fa-magic"></i>
                    </button>
                  </div>
                  <div className="d-flex gap-2">
                    <button
                      type="button"
                      className="btn btn-outline-light no-hover"
                      data-bs-toggle="tooltip"
                      title="Notes"
                      onClick={() => handleNotesModal(open, selectedClient.id)}>
                      <NotesIcon />
                    </button>

                    <button
                      type="button"
                      className="btn btn-outline-light no-hover"
                      data-bs-toggle="tooltip"
                      title="App Gallery"
                      onClick={() =>
                        handleGalleryModal(open, selectedClient.id)
                      }>
                      <i className="far fa-image"></i>
                    </button>

                    <div className="dropdown">
                      <button
                        className="btn btn-outline-light dropdown-toggle"
                        type="button"
                        id="dropdownMenuButton"
                        data-bs-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false">
                        <span data-bs-toggle="tooltip" title="Type of posts">
                          <i className="far fa-eye"></i>
                        </span>
                      </button>
                      <div
                        className="dropdown-menu"
                        aria-labelledby="dropdownMenuButton">
                        <a
                          className="dropdown-item d-flex gap-3 align-items-center"
                          href="#">
                          <i
                            className="fas fa-circle"
                            style={{ color: '#f9b47f' }}
                          />
                          <span className="pt-1">Already Posted</span>
                        </a>
                        <a
                          className="dropdown-item d-flex gap-3 align-items-center"
                          href="#">
                          <i
                            className="fas fa-circle"
                            style={{ color: '#039be5' }}
                          />
                          <span className="pt-1">Post Scheduled</span>
                        </a>
                        <a
                          className="dropdown-item d-flex gap-3 align-items-center"
                          href="#">
                          <i
                            className="fas fa-circle"
                            style={{ color: '#7987a1' }}
                          />
                          <span className="pt-1">Draft Post</span>
                        </a>
                        <a
                          className="dropdown-item d-flex gap-3 align-items-center"
                          href="#">
                          <i
                            className="fas fa-circle"
                            style={{ color: '#10b759' }}
                          />
                          <span className="pt-1">App Post</span>
                        </a>
                        <a
                          className="dropdown-item d-flex gap-3 align-items-center"
                          href="#">
                          <i
                            className="fas fa-circle"
                            style={{ color: '#5E72E4' }}
                          />
                          <span className="pt-1">Google Post</span>
                        </a>
                        <a
                          className="dropdown-item d-flex gap-3 align-items-center"
                          href="#">
                          <i
                            className="fas fa-circle"
                            style={{ color: '#ffca41' }}
                          />
                          <span className="pt-1">Google Offer Post</span>
                        </a>
                        <a
                          className="dropdown-item d-flex gap-3 align-items-center"
                          href="#">
                          <i
                            className="fas fa-circle"
                            style={{ color: '#b181ed' }}
                          />
                          <span className="pt-1">Prompts</span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div className="col-2">
              <div className="d-flex h-100 align-items-center justify-content-end">
                <div
                  className="btn-group"
                  role="group"
                  aria-label="Account and Calendar selector">
                  <button
                    type="button"
                    className="btn btn-light btn-active"
                    onClick={() => {
                      handleProfileView(selectedClient.clientName);
                    }}>
                    Account
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary btn-inactive">
                    Calendar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="content-body pd-0 z-1"
          style={{ height: 'calc(100% - 126px)' }}>
          <NotesModal
            id={clientModalId}
            open={open}
            handleNotesModal={handleNotesModal}
          />

          <div
            id="calendar"
            class={
              'calendar-content-body ' +
              (loadingPosts || isGenerating
                ? 'disable text-muted bg-light'
                : '')
            }
            style={{
              pointerEvents: loadingPosts || isGenerating ? 'none' : 'auto',
              position: 'relative',
              height: '100%',
              overflow: 'auto'
            }}>
            <FullCalendar
              ref={calendarRef}
              scrollTime={false}
              columnHeaderFormat={{ weekday: 'long' }}
              defaultView="dayGridMonth"
              selectable={true}
              eventLimit={false}
              handleWindowResize={true}
              aspectRatio={1.2}
              expandRows={true}
              contentHeight={'auto'}
              displayEventTime={!showPrompts && !loadingPosts}
              fixedWeekCount={false}
              showNonCurrentDates={false}
              themeSystem={'bootstrap'}
              eventRender={(info) => {
                if (info.view.type === 'dayGridMonth') {
                  const eventTitle = info.event.title || '';

                  const hasLineBreak =
                    eventTitle.includes('\n') ||
                    (eventTitle.includes('**Q:') &&
                      eventTitle.includes('**A:')) ||
                    eventTitle.includes('A: Look for missing shingle') ||
                    eventTitle.includes('Is your commercial roof');

                  if (hasLineBreak) {
                    info.el.setAttribute('data-has-line-break', 'true');
                  }
                }

                // List view with images functionality
                if (info.view.type === 'listMonth') {
                  const titleTd = info.el.querySelector('.fc-list-item-title');
                  const reactContainer = document.createElement('div');
                  ReactDOM.render(
                    <CustomListContent obj={info.event} ev={info} />,
                    reactContainer
                  );
                  titleTd.style.display = 'flex';
                  titleTd.style.justifyContent = 'space-between';
                  reactContainer.style.display = 'flex';
                  reactContainer.style.alignItems = 'center';
                  titleTd.appendChild(reactContainer);
                }
                // Show images functionality
                if (
                  info.view.type === 'dayGridMonth' &&
                  showImages &&
                  !showPrompts
                ) {
                  const eventEl = info.el;
                  const originalContent = eventEl.querySelector('.fc-content');
                  const timeEl = originalContent?.querySelector('.fc-time');
                  const titleEl = originalContent?.querySelector('.fc-title');
                  const timeText = timeEl?.innerText || '';
                  const titleText = titleEl?.innerText || '';

                  // Add show-images-mode class for consistent styling
                  eventEl.classList.add('show-images-mode');

                  // Clear the original content
                  eventEl.innerHTML = '';

                  // Main container with fc-content class for proper styling
                  const wrapper = document.createElement('div');
                  wrapper.className = 'fc-content';
                  wrapper.style.display = 'flex';
                  wrapper.style.flexDirection = 'column';
                  wrapper.style.alignItems = 'flex-start';
                  wrapper.style.justifyContent = 'start';
                  wrapper.style.overflow = 'hidden';
                  wrapper.style.padding = '2px';
                  wrapper.style.height = '100%';

                  // Text container with proper class
                  const textContainer = document.createElement('div');
                  textContainer.className = 'text-container';
                  // Ensure only first line is shown by truncating at reasonable length
                  const fullText = `${timeText} ${titleText}`;
                  const truncatedText =
                    fullText.length > 50
                      ? fullText.substring(0, 50) + '...'
                      : fullText;
                  textContainer.innerText = truncatedText;

                  // Imagen
                  const img = document.createElement('img');
                  img.src = info.event.extendedProps.images?.[0]?.url || '';
                  img.alt = '';

                  wrapper.appendChild(textContainer);
                  if (!img.src.includes('/calendar') && img.src) {
                    wrapper.appendChild(img);
                  }
                  eventEl.appendChild(wrapper);
                }
                // Commented out to restore original calendar aesthetics
                // if (!showPrompts) return;
                // if (info.view.type === 'dayGridMonth' && showPrompts) {
                //   const eventElement = info.el;
                //   const content = eventElement.querySelector('.fc-content');
                //   content.classList.add('fc-content-custom');
                // }
              }}
              customButtons={{
                ...(true && {
                  imagesCalendar: {
                    text: showImages ? 'Hide Images' : 'Show Images',
                    click: handleShowImages
                  }
                }),
                ...(true && {
                  genContentV2: {
                    text: isContentAgentProcessing
                      ? 'Processing...'
                      : 'Content Agent',
                    click: async () => {
                      if (isContentAgentProcessing) return; // Prevent multiple clicks

                      console.log('Generate AI Content V2 clicked');
                      setIsContentAgentProcessing(true);

                      try {
                        // Prepare payload: use the visible month in the calendar (queryDate -> "M YYYY")
                        let monthName;
                        let yearName;
                        try {
                          const [mStr, yStr] = String(queryDate || '').split(
                            ' '
                          );
                          const mIdx = Math.max(
                            0,
                            (Number(mStr) || new Date().getMonth() + 1) - 1
                          );
                          monthName = new Date(2000, mIdx, 1).toLocaleString(
                            'en-US',
                            { month: 'long' }
                          );
                          yearName =
                            yStr || new Date().getFullYear().toString();
                        } catch (_) {
                          monthName = new Date().toLocaleString('en-US', {
                            month: 'long'
                          });
                          yearName = new Date().getFullYear().toString();
                        }
                        const payload = {
                          clientId: selectedClient.id,
                          monthName,
                          yearName,
                          realImages: true
                        };

                        // Check if client has NO_AI flag
                        const hasNoAIFlag =
                          selectedClient?.clientFlags?.includes('NO_AI');

                        // Select the appropriate endpoint
                        const apiEndpoint = hasNoAIFlag
                          ? API_GENERATE_AI_POST_V2_NO_AI
                          : API_GENERATE_AI_POST_V2;

                        console.log('Payload:', payload);
                        console.log('Has NO_AI flag:', hasNoAIFlag);
                        console.log('Using endpoint:', apiEndpoint);

                        // Trigger modal + block for 7 min (only for this client)
                        setIsGenerating(true);
                        SetLoadingPosts(true);
                        setBlockingClientId(selectedClient.id);
                        const startedAtNow = Date.now();
                        setGenerationStartTime(startedAtNow);

                        // Make GET with query params (fetch ignores body in GET)
                        const qs = new URLSearchParams({
                          clientId: String(payload.clientId || ''),
                          monthName: String(payload.monthName || ''),
                          yearName: String(payload.yearName || ''),
                          realImages: String(payload.realImages)
                        }).toString();
                        const url = `${apiEndpoint}?${qs}`;
                        console.log('Making request to:', url);

                        // Send request without waiting for response
                        fetch(url, { method: 'GET' })
                          .then((response) => {
                            console.log('Response status:', response.status);
                            console.log('Response ok:', response.ok);
                            return response.text();
                          })
                          .then((responseText) => {
                            console.log('Response text:', responseText);
                          })
                          .catch((err) => {
                            console.error('Error in background request:', err);
                          });

                        // Poll for generatingContentByAI flag to become true
                        const pollForGenerationStart = () => {
                          const pollInterval = setInterval(async () => {
                            try {
                              const clientResponse = await axios.get(
                                `${API_CLIENTS_NAME}${match.params.id}`,
                                {
                                  headers: {
                                    'X-API-KEY': API_KEY,
                                    Authorization: `bearer ${userInfo.accessToken}`
                                  }
                                }
                              );

                              if (
                                clientResponse.data.generatingContentByAI ===
                                true
                              ) {
                                console.log(
                                  'Generation flag detected, reloading page...'
                                );
                                clearInterval(pollInterval);
                                window.location.reload();
                              }
                            } catch (pollError) {
                              console.error(
                                'Error polling for generation status:',
                                pollError
                              );
                            }
                          }, 200); // Poll every 200ms

                          // Safety timeout - if after 10 seconds the flag hasn't changed, reload anyway
                          setTimeout(() => {
                            clearInterval(pollInterval);
                            console.log(
                              'Timeout reached, reloading page anyway...'
                            );
                            window.location.reload();
                          }, 10000);
                        };

                        // Start polling after a small delay to allow the API to process
                        setTimeout(pollForGenerationStart, 200);
                      } catch (err) {
                        console.error('Error generating AI content v2', err);
                        setIsContentAgentProcessing(false); // Reset state on error
                      }
                    }
                  }
                }),
                customTitle: {
                  text: `Prompts${
                    contentStrategy?.strategyName !== undefined
                      ? ' - ' + contentStrategy?.strategyName
                      : ''
                  }`
                }
              }}
              height={'parent'}
              buttonIcons={{
                prev: 'left-single-arrow',
                next: 'right-single-arrow',
                prevYear: 'left-double-arrow',
                nextYear: 'right-double-arrow'
              }}
              views={{
                FourDayView: {
                  type: 'timeGrid',
                  duration: { days: 4 },
                  buttonText: '4 day'
                },
                YearView: {
                  type: 'timeline',
                  buttonText: 'year',
                  dateIncrement: { years: 1 },
                  slotDuration: { months: 1 },
                  duration: { year: 1 }
                }
              }}
              eventClick={onSelectPost}
              eventDrop={(event) => {
                if (showPrompts) return;
                let start;
                if (typeof event.event.start === 'object') {
                  start = new Date(event.event.start).getTime();
                  start = start / 1000;
                  start = Math.floor(start);
                } else {
                  start = event.event.start;
                }
                let getIdxPost = () => {
                  let idx = 0;
                  while (postsLists[idx].id !== event.event.id) {
                    idx++;
                  }
                  return idx;
                };
                let isDraft = false;
                let posted = false;
                let isScheduled = false;
                if (event.event.extendedProps.status === 'Draft') {
                  isDraft = true;
                } else if (event.event.extendedProps.status === 'Posted') {
                  posted = true;
                } else if (event.event.extendedProps.status === 'Scheduled') {
                  isScheduled = true;
                } else {
                }
                let post = {
                  message: event.event.title,
                  images: event.event.extendedProps.images,
                  schedule: start,
                  createdAt: event.event.extendedProps.createdAt,
                  socialNetworks: event.event.extendedProps.socialNetworks,
                  isDraft,
                  recurrentDates: [],
                  posted,
                  isScheduled,
                  createdBy: event.event.extendedProps.createdBy,
                  clientId: selectedClient.id,
                  postId: event.event.id
                };
                let newPostsList = postsLists;
                let idx = getIdxPost();

                newPostsList[idx] = post;
                SetPostsLists(newPostsList);
                dispatch(showLoading());
                SetLoadingPosts(true);
                axios
                  .post(API_POSTS_EDIT, JSON.stringify(post))
                  .then((response) => {
                    fetchPosts(queryDate);
                  })
                  .catch((error) => {
                    fetchPosts(queryDate);
                    if (error) {
                      Swal.fire({
                        title: 'error',
                        text: 'We have trouble scheduling the publication'
                      });
                    }
                    console.error(error);
                  });
              }}
              buttonText={{
                today: 'Today',
                month: 'Month',
                dayGridWeek: 'Week',
                day: 'Day',
                list: 'List'
              }}
              header={{
                left: 'prev,next, today',
                center: `${showPrompts ? 'customTitle' : 'title'}`,
                right:
                  'imagesCalendar, genContentV2, dayGridDay, dayGridWeek, dayGridMonth, listMonth'
              }}
              plugins={[
                dayGridPlugin,
                timeGridPlugin,
                interactionPlugin,
                timeline,
                list,
                bootstrap
              ]}
              events={(fetchInfo, successCallback, failureCallback) =>
                getCalendarDate(fetchInfo, successCallback, failureCallback)
              }
              dateClick={handleDateClick}
              forceEventDuration={true}
              defaultTimedEventDuration={{ minutes: 1 }}
            />
          </div>

          <ViewPostsInCalendar
            ref={viewPostRef}
            contentStrategy={contentStrategy}
            userRole={userInfo}
            posts={postsLists}
            selectedClient={selectedClient}
            carrouselModal={carrouselModal}
            updatePost={updatePost}
            handleShowPrompts={handleShowPrompts}
            deletePost={(id, options) => {
              deletePost(id, options);
            }}
            editPost={(post) => {
              editPost(post);
            }}
            rePost={(post) => {
              rePost(post);
            }}
            repairPost={(post) => {
              repairPost(post);
            }}
            IAPostTools={() => {
              handleClickIATools();
            }}
            post={selectedPost}
            timeZone={getTime(selectedClient.timeZone)}
            time={selectedClient.timeZone}
            getStatusPost={getStatusPost}
            close={() => {
              dispatch(setSelectedPost());
            }}
          />

          <UserGalleryModal
            userId={selectedClient.id}
            clientName={selectedClient.clientName}
            refresh={refresh}
            ref={userGalleryRef}
          />

          <NewPost
            ref={newPostRef}
            post={newPost}
            hideRecurrent={true}
            isCalendar={true}
            callbackPost={(post, used_state) => {
              if (post) {
                fetchPosts(queryDate);
                setNewPost(undefined);
              } else {
                setNewPost(undefined);
              }
              if (used_state) {
                setRefresh(!refresh);
              }
            }}
            currentClientId={selectedClient.id}
            currentClientSocialNetworks={selectedClient.clientSocialNetworks}
            currentClientTimeZone={selectedClient.timeZone}
            currentClientBestTimes={selectedClient.bestTimes}
            currentClientMergeFields={selectedClient.mergeFields}
            currentCustomerName={userInfo.displayName}
            postsLists={postsLists}
          />
          {selectedPost && (
            <AIToolsPost
              fetchPosts={fetchPosts}
              queryDate={queryDate}
              post={selectedPost}
              ref={iAPostToolsRef}
            />
          )}

          {/* Modal flotante para el contador de generación AI */}
          {isGenerating && blockingClientId === selectedClient?.id && (
            <Countdown
              selectedClient={selectedClient}
              generationStartTime={generationStartTime}
              onComplete={() => {
                setIsGenerating(false);
                SetLoadingPosts(false);
                setBlockingClientId(null);
                setGenerationStartTime(null);
                dispatch(resetContentState());
              }}
            />
          )}
        </div>
      </div>
    </NotesProvider>
  );
}

export default CalendarScreen;
